import { Accessibility } from '../types/providerSearch';

export function accessibilityLabel(a: Accessibility, count: number): string {
  if (a === Accessibility.Contracted || a === Accessibility.Recommended) return `${a} (${count})`;
  return a;
}

export default { accessibilityLabel };
